// Central image URL resolver.
//
// Most product images are now self-hosted on our own box, downloaded from the
// stores' Shopify CDN at two sizes and served from /uploads/images/<id>_lg.jpg
// (900px) and _sm.jpg (500px). This resolver picks the size the surface needs.
//
// Images that could NOT be localised (a few dead sources, plus appliance images
// on other CDNs) stay hotlinked; for the Shopify ones we still append ?width=
// so they are not full-size either.
const FILE = process.env.REACT_APP_API_BASE_URL_FILE;

export function ootImg(raw, width) {
  if (!raw) return null;
  let u = /^https?:\/\//.test(raw) ? raw : `${FILE}/images/${raw}`;

  // Self-hosted: .../uploads/images/<id>_lg.jpg -> use _sm for card/thumbnail.
  if (/\/uploads\/images\/\d+_lg\.jpg$/.test(u)) {
    return width && width <= 500 ? u.replace(/_lg\.jpg$/, "_sm.jpg") : u;
  }

  // Still-hotlinked Shopify image: request a resized copy from their CDN.
  if (width && /(^|\.)cdn\.shopify\.com/.test(u)) {
    u += (u.includes("?") ? "&" : "?") + "width=" + width;
  }
  return u;
}

export default ootImg;
